export var NSDataTypes = {}

window.NSDataTypes_ = NSDataTypes;

NSDataTypes.CONSTS = {
    Types:{
        integer: 'integer',
        bigint: 'bigint',
        serial: 'serial',
        bigserial: 'bigserial',

        decimal: 'decimal',
        numeric: 'numeric',
        real: 'real',
        double_precision: 'double precision',

        character_varying: 'character varying',
        varchar: 'varchar',
        character: 'character',
        char: 'char',
        text: 'text',

        date: 'date',
        timestamp_with_time_zone: 'timestamp with time zone',
        timestamp_without_time_zone: 'timestamp without time zone'
    }

}

NSDataTypes.f_type_is_any_text_type = function(s_data_type)
{
    let b_res = (
                    ( s_data_type.indexOf(this.CONSTS.Types.character_varying) > -1)? true :  false 
                    || ( s_data_type.indexOf(this.CONSTS.Types.varchar) > -1)? true :  false 
                    || ( s_data_type.indexOf(this.CONSTS.Types.character) > -1)? true :  false 
                    || ( s_data_type.indexOf(this.CONSTS.Types.char) > -1)? true :  false 
                    || ( s_data_type.indexOf(this.CONSTS.Types.text) > -1)? true :  false 
                )? true :  false;
  
    return b_res;
}

NSDataTypes.f_type_is_any_number_type = function(s_data_type)
{
    let b_res = (
                   this.f_type_is_integer_number(s_data_type)
                   ||
                   this.f_type_is_number_with_decimal_places(s_data_type)
                )? true :  false;

    
    return b_res;
}

NSDataTypes.f_type_is_integer_number = function(s_data_type)
{
    let b_res = (
                    s_data_type == this.CONSTS.Types.integer
                    || s_data_type == this.CONSTS.Types.bigint
                    || s_data_type == this.CONSTS.Types.serial
                    || s_data_type == this.CONSTS.Types.bigserial
                )? true :  false;

    
    return b_res;
}

NSDataTypes.f_type_is_number_with_decimal_places = function(s_data_type)
{
    let b_res = (
                    s_data_type == this.CONSTS.Types.decimal
                    || s_data_type == this.CONSTS.Types.numeric
                    || s_data_type == this.CONSTS.Types.real
                    || s_data_type == this.CONSTS.Types.double_precision
                )? true :  false;

    
    return b_res;
}

NSDataTypes.f_type_is_date_or_datetime = function(s_data_type)
{
    let b_res = (
                   this.f_type_is_date(s_data_type)
                   ||
                   this.f_type_is_datetime(s_data_type)
                )? true :  false;

    
    return b_res;
}

NSDataTypes.f_type_is_date = function(s_data_type)
{
    let b_res = (
                    s_data_type == this.CONSTS.Types.date
                )? true :  false;

    
    return b_res;
}

NSDataTypes.f_type_is_datetime = function(s_data_type)
{
    let b_res = (
                    s_data_type == this.CONSTS.Types.timestamp_with_time_zone
                    || s_data_type == this.CONSTS.Types.timestamp_without_time_zone
                )? true :  false;

    
    return b_res;
}

NSDataTypes.f_type_is_geometry = function(s_data_type)
{
    let b_res = ( s_data_type.indexOf("geometry") > -1)? true :  false;

    return b_res;
}

NSDataTypes.f_geometry_type_is_generic = function(s_data_type)
{
    let b_field_is_geometry = this.f_type_is_geometry(s_data_type);

    let b_res = (b_field_is_geometry && s_data_type.toLocaleLowerCase().indexOf("geometry(geometry") > -1) ? true : false;

    return b_res;
}

NSDataTypes.f_geometry_type_is_point = function(s_data_type)
{
    let b_field_is_geometry = this.f_type_is_geometry(s_data_type);

    let b_res = (b_field_is_geometry && s_data_type.toLocaleLowerCase().indexOf("point") > -1) ? true : false;

    return b_res;
}

NSDataTypes.f_geometry_type_is_polyline = function(s_data_type)
{
    let b_field_is_geometry = this.f_type_is_geometry(s_data_type);

    let b_res = (b_field_is_geometry && s_data_type.toLocaleLowerCase().indexOf("linestring") > -1) ? true : false;


    return b_res;
}

NSDataTypes.f_geometry_type_is_polygon = function(s_data_type)
{
    let b_field_is_geometry = this.f_type_is_geometry(s_data_type);

    let b_res = (b_field_is_geometry && s_data_type.toLocaleLowerCase().indexOf("polygon") > -1) ? true : false;


    return b_res;
}

NSDataTypes.f_geometry_type_is_multipolygon = function(s_data_type)
{
    let b_field_is_geometry = this.f_type_is_geometry(s_data_type);

    let b_res = (b_field_is_geometry && s_data_type.toLocaleLowerCase().indexOf("multipolygon") > -1) ? true : false;


    return b_res;
}

NSDataTypes.f_geometry_type_is_multilinestring = function(s_data_type)
{
    let b_field_is_geometry = this.f_type_is_geometry(s_data_type);

    let b_res = (b_field_is_geometry && s_data_type.toLocaleLowerCase().indexOf("multilinestring") > -1) ? true : false;


    return b_res;
}

NSDataTypes.f_geometry_type_is_multipoint = function(s_data_type)
{
    let b_field_is_geometry = this.f_type_is_geometry(s_data_type);

    let b_res = (b_field_is_geometry && s_data_type.toLocaleLowerCase().indexOf("multipoint") > -1) ? true : false;


    return b_res;
}

NSDataTypes.f_geometry_type_is_collection = function(s_data_type)
{
    let b_field_is_geometry = this.f_type_is_geometry(s_data_type);

    let b_res = (b_field_is_geometry && s_data_type.toLocaleLowerCase().indexOf("collection") > -1) ? true : false;


    return b_res;
}


NSDataTypes.f_get_text_type = function()
{  
    return this.CONSTS.Types.text;
}